import { RootState } from '@iwProvider/configureStore';
import { getCurrentLocation } from '@iwRouter/HistoryProvider';

import { getEarlyRepaymentURLData } from './EarlyRepaymentHelper';
import { getAccountByAccountId } from '../multiLoanDashboard/accountsSelector';

export function getEarlyRepaymentAccountId(state: RootState) {
    return state.earlyRepayment.accountId;
}

export function getEarlyRepaymentStripeKey(state: RootState) {
    const account = getEarlyRepaymentAccount(state);
    return account?.repayment_details?.stripe_publishable_key;
}

function getEarlyRepaymentAccount(state: RootState) {
    const currentLocation = getCurrentLocation();
    const urlData = getEarlyRepaymentURLData(currentLocation);
    return getAccountByAccountId(state, urlData.accountId!);
}
